import * as en from "@/lib/hiatal-hernia";
import * as es from "@/lib/es-hiatal-hernia";

/** Preserve each existing nested sequence while putting the illustration first. */
export function hiatalTypeGalleries(lang: "en" | "es"): Partial<Record<en.HiatalImageKey, en.HiatalFigure[]>> {
  const spanish = lang === "es";
  const figures = spanish ? es.ES_HIATAL_FIGURES : en.HIATAL_FIGURES;
  return {
    type1: [figures.type1,
      ...(spanish ? [es.ES_HIATAL_SLEEVE_SCAN, es.ES_HIATAL_SLEEVE_SCAN_SECOND, es.ES_HIATAL_TYPE1_REPAIR, es.ES_HIATAL_TYPE1_ESOPHAGUS, es.ES_HIATAL_TYPE1_COMPLETED, es.ES_HIATAL_TYPE1_WEIGHT] : [en.HIATAL_SLEEVE_SCAN, en.HIATAL_SLEEVE_SCAN_SECOND, en.HIATAL_TYPE1_REPAIR, en.HIATAL_TYPE1_ESOPHAGUS, en.HIATAL_TYPE1_COMPLETED, en.HIATAL_TYPE1_WEIGHT])],
    type2: [figures.type2, spanish ? es.ES_HIATAL_TYPE2_SLEEVE_SCAN : en.HIATAL_TYPE2_SLEEVE_SCAN,
      ...(spanish ? es.ES_HIATAL_TYPE2_PATIENT_STORY : en.HIATAL_TYPE2_PATIENT_STORY)],
    type3: [figures.type3,
      ...(spanish ? [es.ES_HIATAL_TYPE3_SLEEVE_SCAN_SECOND, es.ES_HIATAL_TYPE3_SLEEVE_SCAN, ...es.ES_HIATAL_TYPE3_PATIENT_STORY] : [en.HIATAL_TYPE3_SLEEVE_SCAN_SECOND, en.HIATAL_TYPE3_SLEEVE_SCAN, ...en.HIATAL_TYPE3_PATIENT_STORY])],
    type4: [figures.type4, spanish ? es.ES_HIATAL_TYPE4_UPPER_GI : en.HIATAL_TYPE4_UPPER_GI,
      ...(spanish ? es.ES_HIATAL_TYPE4_PATIENT_STORY : en.HIATAL_TYPE4_PATIENT_STORY)],
  };
}